import { AnalyticsEventLocation } from '@mb/lib';
import { ProductSearchMaterial } from '../../types';
import { getUserAttributes } from '../localstorage';
import { mapProductToAnalyticsEcommerceItem } from './analytics';
import { goToLogin } from './goToLogin';
import { sendAnalytics } from '../../api/events';
import { getEventsMaterialProps } from '../../helpers';

interface BoardsModalProps {
  itemsData: any[];
  onSuccessAnalyticsEvents: any;
}

export const triggerBoardsModal = ({
  itemsData = [],
  onSuccessAnalyticsEvents = [],
}: BoardsModalProps) => {
  const userData = getUserAttributes();

  if (userData?.signin_token == null) {
    goToLogin();
    return;
  }

  window.dispatchEvent(
    new CustomEvent('open-save-to-board-modal', {
      detail: {
        itemsData,
        // Leaving the "itemIds" for now for backward compatibility
        itemIds: itemsData.map((item) => String(item.id)),
        onSuccessAnalyticsEvents,
      },
    }),
  );
};

const currencies = {
  US: 'USD',
  EU: 'EUR',
  JP: 'JPY',
};
interface AddToBoardsProps {
  product: ProductSearchMaterial;
  index: number;
  itemListId: string;
  itemListName: string;
  analyticsEventLocation?: AnalyticsEventLocation;
}

export const handleAddToBoards = async ({
  product,
  index,
  analyticsEventLocation,
  itemListId,
  itemListName,
}: AddToBoardsProps) => {
  const currentItemId = product?.entityId;
  const analyticsProps = getEventsMaterialProps(product);
  const addToWishlistEventItem = mapProductToAnalyticsEcommerceItem({
    product,
    itemListId,
    itemListName,
    index: index !== undefined ? index + 1 : undefined,
  });

  const isFinishMaterial = product.isFinish;

  triggerBoardsModal({
    itemsData: [
      {
        id: currentItemId,
        type: isFinishMaterial ? 'finish' : 'material',
        associatedProductId: null,
      },
    ],
    onSuccessAnalyticsEvents: [
      { ecommerce: null },
      {
        event: 'add_to_wishlist',
        list_id: product?.isDigital ? 'digital_sampling' : itemListId,
        list_name: product?.isDigital ? 'Digital sampling' : itemListName,
        method: 'Single',
        type: 'Materials',
        name: null,
        action: null,
        experiment_name: null,
        experiment_version: null,
        event_location: analyticsEventLocation ?? '',
        ecommerce: {
          currency: currencies[ENVIRONMENT_REGION],
          value: 0,
          items: [addToWishlistEventItem],
        },
      },
    ],
  });
  const stringIds = [String(currentItemId)];
  await sendAnalytics({
    id: stringIds,
    type: 'favorite',
    ...analyticsProps,
  });
};
